import Reflux from 'reflux';
import GridActions from '../action/gridActions';

const GridStore = Reflux.createStore({
  listenables: GridActions,
  onPublishHelper(data) {
    this.trigger(data);
  },
});

export default GridStore;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/store/gridStore.js
 **/